import React, { useEffect, useState, useRef, useMemo } from 'react'
import { Router, Switch, Route, NavLink, useRouteMatch, Link, Redirect } from 'react-router-dom'
import { FormattedMessage, useIntl } from 'react-intl'

import Form from './components/Form'
import FormSubmitted from './components/FormSubmitted'

import messages from './messages'
import Icon from 'components/Icon'

const SupplierSignUp = ({ match, location }) => {
  const { formatMessage } = useIntl()
  const { url } = useRouteMatch()

  return (
    <div className="w-full h-full relative">
      <div className="absolute top-4 right-0 w-32 h-6">
        <FormattedMessage {...messages.help} /> <Icon icon="life-ring" />
      </div>

      <Switch>
        <Route exact path={url} component={Form} />
        <Route exact path={`${url}/submitted`} component={FormSubmitted} />
      </Switch>
    </div>
  )
}

export default SupplierSignUp
